import React, { Component } from 'react';
import { HttpRequestService } from '../../services/HttpRequestService';
import { UtilsService } from '../../services/UtilsService';
import CustomerTypeInformation from './CustomerTypeInformation';

class EditCustomerType extends Component {
    constructor(props) {
        super(props);
        this.http = new HttpRequestService();
        this.utils = new UtilsService();
        this.state = {
            customerType: null,
        }
        this.handleCustomerTypeChange = this.handleCustomerTypeChange.bind(this);
        this.updateCustomerType = this.updateCustomerType.bind(this);
    }

    componentDidMount() {
        this.getCustomerType();
    }

    handleCustomerTypeChange(customerType) {
        this.customerType = customerType;
    }

    getCustomerType() {
        var params = {
            id: this.props.match.params.id
        }
        this.http.get('/api/Admin/GetCustomerType', params).then(data => {
            this.setState({
                customerType: data,
            });
        })
    }

    updateCustomerType() {
        var params = this.customerType;
        params.customerTypeID = this.props.match.params.id;
        this.http.post('/api/Admin/UpdateCustomerType', params).then(data => {
            this.utils.success("");
        });
    }

    render() {
        return (
            <div className="page-inner">
                <div className="page-header">
                    <h4 className="page-title">Edit Customer Type</h4>
                </div>
                <div className="row">
                    <div className="col-md-12">
                        <div className="card">
                            <div className="card-header">
                                <div className="card-title">Customer Type Information</div>
                            </div>
                            <div className="card-body">
                                {this.state.customerType &&
                                    <CustomerTypeInformation customerType={this.state.customerType} onChange={this.handleCustomerTypeChange}></CustomerTypeInformation>
                                }
                            </div>
                            <div className="card-footer">
                                <button className="btn btn-primary btn-default pull-right mr-2" onClick={this.updateCustomerType}>Update</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default EditCustomerType